<template>
  <div class="page-card">
    <el-card>
      <div slot="header">首页功能图标管理</div>
      <el-button type="success" size="small" @click="openEdit()">新增功能图标</el-button>
      <el-table :data="list" border stripe style="margin-top: 12px;">
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="图标" width="80">
          <template slot-scope="scope">
            <img v-if="scope.row.iconImage" :src="scope.row.iconImage" style="width: 40px; height: 40px; object-fit: contain;" />
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" />
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="editForm.id ? '编辑功能图标' : '新增功能图标'" :visible.sync="editVisible" width="500px">
        <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="90px">
          <el-form-item label="名称" prop="name">
            <el-select
              v-model="editForm.name"
              filterable
              allow-create
              default-first-option
              placeholder="选择或输入名称"
              style="width: 100%;"
            >
              <el-option label="餐饮" value="餐饮" />
              <el-option label="酒店" value="酒店" />
              <el-option label="景区" value="景区" />
              <el-option label="ETC服务" value="ETC服务" />
              <el-option label="充电站" value="充电站" />
              <el-option label="生活服务" value="生活服务" />
            </el-select>
          </el-form-item>
          <el-form-item label="图标" prop="iconImage">
            <el-upload
              :key="uploadKey"
              class="avatar-uploader"
              action=""
              list-type="picture-card"
              :file-list="iconFileList"
              :http-request="uploadNavIcon"
              :before-upload="beforeIconUpload"
              :on-remove="handleIconRemove"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" @click="save">保 存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request, {
  resolveUploadedFileUrl,
  pickUploadResponsePayload,
  normalizeMediaUrl
} from '@/api/request'

export default {
  name: 'NavList',
  data() {
    return {
      list: [],
      editVisible: false,
      uploadKey: 0,
      editForm: {
        id: null,
        name: '',
        iconImage: '',
        path: '',
        desc: '',
        order: 0
      },
      iconFileList: [],
      editRules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        iconImage: [
          {
            validator: (rule, value, callback) => {
              const hasList = this.iconFileList && this.iconFileList.length > 0
              const hasIcon = this.editForm.iconImage
              if (hasList || hasIcon) {
                callback()
              } else {
                callback(new Error('请上传图标'))
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request.get('/navs').then(res => {
        const data = res.data || res
        const items = (data && data.items) || []
        this.list = items.map(item => ({
          ...item,
          iconImage: normalizeMediaUrl(item.iconImage || '') || item.iconImage
        }))
      })
    },
    openEdit(row) {
      if (row && row.id) {
        const iconRaw = (row.iconImage || '').trim()
        const icon = normalizeMediaUrl(iconRaw) || iconRaw
        this.editForm = { ...row, iconImage: icon }
        this.iconFileList = icon ? [{ name: 'icon', url: icon }] : []
      } else {
        this.editForm = {
          id: null,
          name: '',
          iconImage: '',
          path: '',
          desc: '',
          order: 0
        }
        this.iconFileList = []
      }
      this.uploadKey += 1
      this.editVisible = true
    },
    save() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const data = { ...this.editForm }
        const req = data.id ? request.put(`/navs/${data.id}`, data) : request.post('/navs', data)
        req.then(() => {
          this.$message.success('保存成功')
          this.editVisible = false
          this.fetchList()
        })
      })
    },
    remove(row) {
      this.$confirm('确认删除该功能图标吗？', '提示', { type: 'warning' }).then(() => {
        request.delete(`/navs/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    },
    handleIconRemove(file, fileList) {
      this.iconFileList = fileList
      this.editForm.iconImage = fileList.length ? fileList[0].url : ''
    },
    beforeIconUpload(file) {
      const okType = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'].includes(file.type)
      if (!okType) {
        this.$message.error('仅支持 png/jpg/jpeg/webp/gif')
        return false
      }
      if (file.size / 1024 / 1024 > 2) {
        this.$message.error('图标建议不超过 2MB')
        return false
      }
      return true
    },
    uploadNavIcon(req) {
      const form = new FormData()
      form.append('file', req.file)
      request
        .post('/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          const data = pickUploadResponsePayload(res)
          const url = resolveUploadedFileUrl(data)
          if (!url) throw new Error('empty url')
          this.iconFileList = [{ name: req.file.name || 'icon', url }]
          this.editForm.iconImage = url
          req.onSuccess && req.onSuccess({ url })
        })
        .catch(err => {
          this.$message.error('图标上传失败')
          req.onError && req.onError(err)
        })
    }
  }
}
</script>

<style scoped>
.avatar-uploader ::v-deep .el-upload-list__item-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: contain;
  background: #fff;
}
</style>

